module.exports = __webpack_public_path__ + "static/media/Canada.5638296f.svg";